import type { Connection, MatterStatuteOfLimitations } from "@/lib/types";
import {
  createContactConnectionChildInput,
  getActiveContactConnections,
} from "./item-contact-connections";

const STATUTE_DEFENDANT_CONNECTION_TYPES = [
  "matter_statute_of_limitations_to_statute_defendant",
  "matter_statute_of_limitations_to_legacy_statute_defendant",
] as const;

export const getStatuteDefendantConnections = (
  statute: MatterStatuteOfLimitations | undefined,
): Connection[] =>
  STATUTE_DEFENDANT_CONNECTION_TYPES.flatMap((connectionType) =>
    getActiveContactConnections(
      statute,
      "matter_statute_of_limitations",
      connectionType,
    ),
  );

export const getStatuteDefendantConnection = (
  statute?: MatterStatuteOfLimitations,
): Connection | undefined => getStatuteDefendantConnections(statute)[0];

export const createStatuteDefendantConnectionChildInput = (contactId: string) =>
  createContactConnectionChildInput(
    contactId,
    "matter_statute_of_limitations_to_statute_defendant",
  );

export const STATUTE_DEFENDANT_CONNECTION_TYPE =
  "matter_statute_of_limitations_to_statute_defendant";
